// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4994) return "static/chunks/4994-fa3f480fe78dfcbb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1088":"05387f903c0e7f42","6045":"bea505370794aff6"}[chunkId] + ".js";
};